<template lang="jade">
  .container-fluid.frame(v-bind:name="hasUser()")
    .row
      .col-md-12.no_pad.frame_group
        //- .info
        //-   span window.innerHeight is {{wh}}
        //-   span piSideBarHeight is {{piSideBarHeight}}
        //-   span piBodyHeight is {{piBodyHeight}}
        //-   span piMainHeight is {{piMainHeight}}
        iframe#iframe(
          v-bind:src="iframeSrc"
          v-if="hasUser"
          name="{{isInstaller ? '1' : '0'}}"
          v-bind:style="iframeStyle"
          )
</template>
<script>
import MobileDetect from 'mobile-detect'
import { getUser } from 'src/Service'
import $ from 'jquery'
// const MOBILE_HEADER_HEIGHT = 40

export default {
  data: () => ({
    iframeSrc: '',
    ww: 0,
    wh: 0,
    piSideBarHeight: 0,
    piBodyHeight: 0,
    piMainHeight: 0,
    isInstaller: false,
    iframeLoaded: false,
    user: -1
  }),
  computed: {
    isMobile () {
      let md = new MobileDetect(window.navigator.userAgent)
      return md.mobile() !== null && this.wh > this.ww
    },
    hasUser () {
      return !!this.user
    },
    iframeStyle () {
      return {
        'height': (this.wh - 40) + 'px'
      }
    }
  },
  methods: {
    checkIframeLoaded () {
      if (this.iframeLoaded) return
      let iframe = document.getElementById('iframe')
      if (!iframe) {
        console.log('iframe not ready')
        window.setTimeout(this.checkIframeLoaded, 3000)
        return
      }
      let iframeDoc = iframe.contentDocument || iframe.contentWindow.document
      if (!iframeDoc) {
        console.log('iframe not ready')
        window.setTimeout(this.checkIframeLoaded, 3000)
        return
      }
      // Check if loading is complete
      if (iframeDoc.readyState === 'complete') {
        this.iframeLoaded = true
        this.adjustPiUiSize()
        return
      }
    },
    adjustPiUiSize (e) {
      let md = new MobileDetect(window.navigator.userAgent)
      setTimeout(() => {
        this.ww = window.innerWidth
        this.wh = window.innerHeight
        console.log('is mobile ', md.mobile())
        console.log('ww', this.ww)
        console.log('wh', this.wh)
        // if (window.matchMedia('(orientation: landscape)').matches && md.mobile() !== null) {
        if (md.mobile() !== null) {
          if (e) {
            console.log('event type', e.type)
            console.log('event', e)
          }
          let body = document.getElementById('iframe').contentWindow.document.getElementsByTagName('body')
          let main = document.getElementById('iframe').contentWindow.document.getElementsByClassName('main')
          let innerSidebar = document.getElementById('iframe').contentWindow.document.getElementsByClassName('sidebar')
          $(body).css({
            // 'outline': '5px solid #f00',
            // 'outline-offset': '-5px',
            'height': (this.wh - 40) + 'px'
          })

          $(innerSidebar).css({
            'height': (this.wh - 40) + 'px'
          })

          $(main).css({
            // 'outline': '4px solid #0f0',
            // 'outline-offset': '-13px',
            'height': (this.wh - 40) + 'px',
            'overflow': 'scroll'
          })
          // $(innerSidebar).height(this.wh)
        }
      }, 200)
    }
  },
  ready () {
    this.iframeSrc = `/ite/?mac=${this.$route.params.mac}`
    this.ww = window.innerWidth
    this.wh = window.innerHeight
    this.user = getUser()
    this.checkIframeLoaded()

    // typof null is an object, wtf?
    if (typeof this.user === 'object' && this.user !== null) {
      if (this.user.hasOwnProperty('installer')) {
        this.isInstaller = this.user.installer || this.user.admin
        this.iframeSrc = `/ite/?mac=${this.$route.params.mac}&name=${this.isInstaller ? 1 : 0}`
      }
    }
    console.log('innder wit', window.innerWidth)
    window.addEventListener('orientationchange', this.adjustPiUiSize, false)
    window.addEventListener('resize', this.adjustPiUiSize, false)
  },
  route: { // add these code to index of every type of devices to reload data
    canReuse: false, // can't reuse so forces it to reload data
    activate ({next}) {
      next()
    },
    deactivate (transition) {
      window.removeEventListener('orientationchange', this.adjustPiUiSize, false)
      window.removeEventListener('resize', this.adjustPiUiSize, false)
      transition.next()
    }
  },
  watch: {
    iframeLoaded (nv) {
      if (nv) this.adjustPiUiSize()
    }
  },
  events: {
    user (uid, user) {
      this.user = user
      this.isInstaller = user.installer || user.admin
      this.iframeSrc = `/ite/?mac=${this.$route.params.mac}&name=${this.isInstaller ? 1 : 0}`
      this.adjustPiUiSize()
    }
  }
}
</script>

<style lang='scss' scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';
.frame{
  .row{
    // height: 100%;
    .frame_group{
      height: 100%;
      // padding-top: 31px;
      // overflow-y: scroll;
      // overflow-x: hidden;
      position: relative;
      // add following to enable mobile touch
      -webkit-overflow-scrolling:touch;
    }
  }
}
.info {
  z-index: 30;
  background-color: #000;
  color: #fff;
  width: 400px;
  height: 200px;
  top: 0;
  left: 300px;
  position: absolute;
  opacity: 0.7;
}
#iframe{
  width: 100%;
  height: 100vh;
  border: none;
  overflow: hidden;
  // position: absolute;
  // outline: 4px solid #f00;
}

.mask{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  left: 0;
  text-align: center;
  line-height: 100%;
  background-color: $base-black;
  color: $base-white;
  & h2{
    position: fixed;
    margin-top: 30%;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// iframe.vue?b85a3000